export const handle400 = (response, context) => {
  Object.keys(response)
    .forEach(key => {
      const ucKey = key.charAt(0).toUpperCase() + key.substr(1)
      if (Array.isArray(response[key])) {
        response[key].forEach(message => {
          context.$notify.danger(context.$t(ucKey + ': ' + message))
        })
      } else {
        context.$notify.danger(context.$t(ucKey + ': ' + response[key]))
      }
    })
}



// WEBPACK FOOTER //
// ./src/utils/responseUtils.js